module.exports = __webpack_public_path__ + "img/map_phase_marker.f4cafbf6.svg";